import type {
	MetricInfo,
	SectionPlanInfo,
	SetPlanInfo,
	StepPlanInfo,
	StepPlanInfoId,
} from '@az3fr/core';

import { sectionPlanSliceSelectors } from '@/entities/section-plan/model/section-plan.selector';
import { setPlanSliceSelectors } from '@/entities/set-plan/model/set-plan.selector';
import { stepPlanSliceSelectors } from '@/entities/step-plan/model/step-plan.selector';
import { useAppSelector } from '@/hooks/store.hook';

/**
 * Custom hook to fetch all data needed for the SetsEditor
 * Consolidates all Redux selectors in one place
 */
export function useSetsEditorData(stepPlanId: StepPlanInfoId): {
	stepPlan: StepPlanInfo;
	sectionPlan: SectionPlanInfo;
	setPlans: SetPlanInfo[];
	populatedTrackedMetrics: MetricInfo[];
} | null {
	const stepPlan = useAppSelector((state) => stepPlanSliceSelectors.selectById(state, stepPlanId));

	const sectionPlan = useAppSelector((state) =>
		sectionPlanSliceSelectors.selectById(state, stepPlan?.sectionPlanId ?? ''),
	);

	const setPlans = useAppSelector((state) =>
		setPlanSliceSelectors.selectAllByStepPlanId(state, stepPlanId),
	);

	const populatedTrackedMetrics = useAppSelector((state) =>
		stepPlanSliceSelectors.selectPopulatedTrackedMetricsByStepPlanId(state, stepPlanId),
	);

	// Early return if required data is not available
	if (!stepPlan || !sectionPlan || !populatedTrackedMetrics) {
		return null;
	}

	return {
		stepPlan,
		sectionPlan,
		setPlans,
		populatedTrackedMetrics,
	};
}
